import styled, { css } from 'styled-components';

import { NegativeFill } from 'ui/icons/status/NegativeFill';
import { pxToRem } from 'utils/convert';
import { colors, spacing } from 'ui/theme';

import { BasicOption } from './BasicOption';
import { BASIC_SELECT_SIZES } from './constants';

export const ErrorIcon = styled(NegativeFill)`
  path {
    fill: ${colors.iconDestructive};
  }
`;

export type IconWrapperProps = {
  isReadOnly?: boolean;
};

export const IconWrapper = styled.span<IconWrapperProps>`
  padding: 0 ${spacing.half};
  position: relative;
  top: ${spacing.eighth};

  > * + * {
    margin-left: ${spacing.half};
  }

  ${({ isReadOnly }) =>
    isReadOnly &&
    css`
      path {
        stroke: ${colors.textSecondary};
      }
    `}
`;

export const ValueDisplay = styled(BasicOption)<{ size?: BASIC_SELECT_SIZES }>`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  padding: ${({ size }) =>
    size === BASIC_SELECT_SIZES.SMALL ? `${spacing.quarter} ${spacing.half}` : spacing.half};
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;

  :hover {
    background: inherit;
  }
`;

export const ValueWrapper = styled.button<{ size?: BASIC_SELECT_SIZES }>`
  align-items: center;
  background: transparent;
  border: none;
  border-radius: ${spacing.quarter};
  color: inherit;
  display: flex;
  flex: 1 1 auto;
  font-family: inherit;
  font-size: inherit;
  height: ${({ size }) => (size === BASIC_SELECT_SIZES.SMALL ? pxToRem(34) : pxToRem(38))};
  justify-content: space-between;
  padding-left: ${spacing.quarter};
  padding-right: ${spacing.quarter};
  outline: none;
  width: 100%;
`;
